<template>
  <div v-if="this.checkMobile()" class="grey-background-container">
    <MobileNavigationBack :moduleRoute="moduleRoute" :appbarTitle="moduleRoute"></MobileNavigationBack>
    <br />
    <br />

    <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 mb-5 pb-2">
      <MobileBsIndex :routeDef="moduleRoute" :headersDef="headers">
      </MobileBsIndex>
    </div>

    <div v-if="moduleRoute === 'users'" class="grid grid-cols-6 gap-1 text-center mt-1 mb-1">
      <!-- If users then nothing will be rendered -->
    </div>

    <div v-else-if="moduleRoute === 'audits'" class="grid grid-cols-6 gap-1 text-center mt-1 mb-1">
      <!-- If audits then nothing will be rendered -->
    </div>

    <jet-nav-link v-else @click="goToCreate" class="fixed bottom-0 right-0 mb-4 mr-4 hover:no-underline">
      <div class="bg-blue-500 p-3 hover:cursor-pointer rounded-full shadow" style="display: inline-block">
        <i class="fas fa-plus text-white text-xl d-flex justify-content-center"></i>
      </div>
    </jet-nav-link>
  </div>
  <div v-else>
    <app-layout :title="title">
      <template v-slot:sidenav> </template>

      <template v-slot:horizonav>
        <nav-bar :scId="currentProduct" scType="product"> </nav-bar>
      </template>

      <div class="mt-3">
        <PageTitle :headerTitle="title"> </PageTitle>
      </div>
      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <p class="text-xs">
          We’re updating the cards and ranking all the time, so check back
          regularly.
        </p>
      </div>
      <div>
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
          <!-- cards start from here -->
          <div class="grid grid-cols-5 gap-1 my-3">
            <!-- 1 -->
            <div class="p-2" v-for="item in cardData" :key="item.id">
              <div class="group relative flex gap-x-6 rounded p-2 bg-gray-50">
                <div class="mt-1 flex h-9 w-9 flex-none items-center justify-center rounded-lg bg-white">
                  <svg class="h-6 w-6 text-gray-600" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 6a7.5 7.5 0 107.5 7.5h-7.5V6z" />
                    <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 10.5H21A7.5 7.5 0 0013.5 3v7.5z" />
                  </svg>
                </div>
                <div>
                  <h5 class="font-semibold text-gray-900">
                    {{ item.count }}
                    <span class="absolute inset-0"></span>
                  </h5>
                  <p class="text-gray-600 text-xs">{{ item.label }}</p>
                </div>
              </div>
            </div>
          </div>
          <!-- cards end here -->

          <div>
            <div>
              <div v-if="moduleRoute === 'users'" class="grid grid-cols-6 gap-1 text-center mt-1 mb-1">
                <!-- If users then nothing will be rendered -->
              </div>

              <div v-else-if="moduleRoute === 'audits'" class="grid grid-cols-6 gap-1 text-center mt-1 mb-1">
                <!-- If audits then nothing will be rendered -->
              </div>
              <div v-else>
                <div class="flex justify-between">
                  <div class="flex justify-start">
                    <div>
                      <jet-dropdown-list>
                        <template #trigger>
                          <jet-button
                            class="bg-blue-500 rounded text-white hover:bg-blue-700 hover:no-underline px-2 cursor-pointer text-sm">
                            &nbsp; {{ selectedReportLabel }}

                            <svg class="ml-2 -mr-0.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                              fill="currentColor">
                              <path fill-rule="evenodd"
                                d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                                clip-rule="evenodd" />
                            </svg>
                          </jet-button>
                        </template>

                        <template #content>
                          <div class="dropdown-section">
                            <!-- Preferences List - Keep this unchanged -->
                            <div class="preferences-container mb-2">
                              <jet-dropdown-link v-for="item in saveViews.preference_list" :key="item.id"
                                @click="loadReport(item)" class="preference-link">
                                <div class="flex justify-between items-center">
                                  <span>{{ item.name }}</span>
                                  <svg v-if="item.id === saveViews.selected?.id" xmlns="http://www.w3.org/2000/svg"
                                    class="h-5 w-5 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                      d="M5 13l4 4L19 7" />
                                  </svg>
                                </div>
                              </jet-dropdown-link>
                            </div>

                            <!-- Divider -->
                            <div class="dropdown-divider my-2"></div>

                            <!-- Settings Section - Modified to prevent network calls -->
                            <div class="settings-section">
                              <div class="settings-header text-xs text-gray-500 px-4 py-1">Settings</div>

                              <!-- Renamed to use div instead of jet-dropdown-link -->
                              <div @click.stop.prevent="renamePreference"
                                class="settings-action px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out flex items-center cursor-pointer">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2 inline" fill="none"
                                  viewBox="0 0 24 24" stroke="currentColor">
                                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                </svg>
                                Rename
                              </div>

                              <!-- Same approach for Delete -->
                              <div @click.stop.prevent="deletePreference"
                                class="settings-action px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out flex items-center cursor-pointer">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2 inline" fill="none"
                                  viewBox="0 0 24 24" stroke="currentColor">
                                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                </svg>
                                Delete
                              </div>

                              <!-- Same approach for Set as Default -->
                              <div @click.stop.prevent="setDefaultPreference"
                                class="settings-action px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out flex items-center cursor-pointer">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2 inline" fill="none"
                                  viewBox="0 0 24 24" stroke="currentColor">
                                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M5 13l4 4L19 7" />
                                </svg>
                                Set as Default
                              </div>
                              <div @click.stop.prevent="publishPreference"
                                class="settings-action px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out flex items-center cursor-pointer publish">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2 inline" fill="none"
                                  viewBox="0 0 24 24" stroke="currentColor">
                                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
                                </svg>
                                Publish
                              </div>
                            </div>
                          </div>
                        </template>
                      </jet-dropdown-list>
                    </div>
                    <div>
                      <jet-button
                        class="bg-blue-500 rounded text-white hover:bg-blue-700 hover:no-underline px-2 ml-2 cursor-pointer text-sm"
                        @click="goToCreate">
                        <i class="fa fa-plus" aria-hidden="true"></i>
                        &nbsp; New {{ moduleLabel }}</jet-button>
                    </div>
                  </div>

                  <div class="flex justify-start space-x-2 mr-3">
                    <div>
                      <button v-if="showResetButton" @click="resetGrid" class="px-2 py-1  ">
                        reset
                      </button>
                    </div>
                    <div>
                      <DxDropDownButton v-if="showSaveButton" :items="options" :text="defaultSaveText" keyExpr="id"
                        displayExpr="text" @buttonClick="onButtonClick" @item-click="onItemClick" :splitButton="true"
                        :width="90" stylingMode="contained" :elementAttr="{ class: 'custom-white-button' }" />

                      <DxPopup :visible="showSavePopup" :show-title="true" title="Save Preference" :drag-enabled="false"
                        :close-on-outside-click="true" :width="350" :height="200" container=".dx-viewport"
                        position="{ at: 'center', my: 'center' }" class="custom-popup" @hiding="showSavePopup = false">
                        <div class="popup-content">
                          <label class="label">Preference Name</label>

                          <input v-model="preferenceName" type="text" class="input-field"
                            placeholder="Enter Layout Name" />

                          <div class="button-container">
                            <button @click="onButtonClick" class="save-button">
                              Save
                            </button>
                          </div>
                        </div>
                      </DxPopup>
                      <!-- Updated Rename Popup with Default Checkbox -->
                      <DxPopup :visible="showRenamePopup" :show-title="true" title="Rename layout" :drag-enabled="false"
                        :close-on-outside-click="false" :width="400" :height="220" :show-close-button="false"
                        container=".dx-viewport" position="{ at: 'center', my: 'center' }" class="custom-popup">
                        <div class="popup-content p-4">
                          <label class="label font-semibold text-gray-700">Current Name</label>
                          <input type="text" class="input-field mb-4 p-2 border rounded w-full"
                            v-model="currentPreferenceName" />

                          <div class="mt-2 flex items-center">
                            <input type="checkbox" v-model="makeDefault" class="form-checkbox h-4 w-4 text-blue-600" />
                            <span class="ml-2 text-sm text-gray-700">Set as Default</span>
                          </div>

                          <div class="-mt-3 flex justify-end">
                            <button @click="saveNewName" class="save-button bg-blue-600 text-white px-4 py-2 rounded">
                              Save
                            </button>
                            <button @click="cancelRename"
                              class="cancel-button ml-2 text-gray-600 px-4 py-2 border rounded">
                              Cancel
                            </button>
                          </div>
                        </div>
                      </DxPopup>

                    </div>
                    <div>
                      <LayoutSwitch @layout_selected="currentLayout = $event" @tooltip_shown="handleTooltipShown" />
                    </div>
                    <DxTooltip v-if="tooltip.text" :target-element="tooltip.target" :show-event="'mouseenter'"
                      :hide-event="'mouseleave'" position="top" :visible="!!tooltip.text">
                      {{ tooltip.text }}
                    </DxTooltip>
                  </div>
                </div>
              </div>

              <div class="my-2">
                <div class="bg-white overflow-hidden shadow-xl px-2 py-2 sm:rounded-lg">
                  <BsIndex v-if="currentLayout === 'list'" @item_selected="OnItemSelected" :routeDef="moduleRoute"
                    :slug="slug" :headersDef="headers" :dataRoute="dataRoute" ref="bsIndexRef" :saveViews="saveViews"
                    @isChanged="handleGridChange">
                  </BsIndex>

                  <BsIndexPivot v-else-if="currentLayout === 'pivot'" @item_selected="OnItemSelected"
                    :routeDef="moduleRoute" :slug="slug" :headersDef="pivotHeaders" :dataRoute="dataRoute"
                    ref="bsIndexRef">
                  </BsIndexPivot>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </app-layout>

  </div>
</template>

<style>
.grey-background-container {
  background-color: #ffffff;
  height: 100%;
}

p {
  /* margin-top: 0; */
  margin-bottom: 0.1rem;
}

h5 {
  margin-bottom: 0.1rem;
}

.custom-popup {
  border-radius: 8px;
}

.popup-content {
  padding: 16px;
  display: flex;
  flex-direction: column;
}

.label {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #333;
}

.input-field {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
}

.input-field:focus {
  border-color: #007bff;
}

.button-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}

.save-button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.3s;
}



.save-button:hover {
  background-color: #0056b3;
}

.dropdown-section {
  min-width: 180px;
}

.dropdown-header {
  padding: 8px 12px;
  background-color: #f3f4f6;
  font-weight: 500;
  color: #374151;
  border-bottom: 1px solid #e5e7eb;
}

.preference-item {
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.preference-actions {
  display: flex;
  gap: 8px;
  font-size: 0.875rem;
  color: #6b7280;
}

.action-link {
  cursor: pointer;
  color: #6b7280;
}

.action-link:hover {
  color: #374151;
  min-width: 100px;
}


.custom-white-button .dx-button {
  background-color: #007bff !important;
  color: white !important;
  border-color: white !important;
}

.custom-white-button .dx-button-content {
  color: #ffffff !important;
}

.dx-dropdownbutton-action .dx-icon {
  color: #007bff !important;
}

.custom-white-button .dx-dropdownbutton-toggle .dx-icon {
  color: white !important;
}

.custom-white-button .dx-dropdownbutton-toggle {
  background-color: #007bff !important;

}

</style>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import BsIndex from "@/Base/BsIndex.vue";
import BsIndexPivot from "@/Base/BsIndexPivot.vue";
import MobileBsIndex from "@/Base/MobileBsIndex.vue";
//import { DxDataGrid } from 'devextreme-vue/data-grid';
import DataSource from "devextreme/data/data_source";
import "devextreme/data/odata/store";
import PageTitle from "@/Layouts/PageTitle.vue";
import jetDropdownList from "@/Jetstream/DropdownList.vue";
import JetDropdownLink from "@/Jetstream/DropdownLink.vue";
import JetNavLink from "@/Jetstream/NavLink.vue";
import JetButton from "@/Jetstream/Button.vue";
import MobileNavigation from "@/Layouts/MobileNavigation.vue";
import MobileNavigationBack from "@/Layouts/MobileNavigationBack.vue";
import NavBar from "../../Layouts/NavBar.vue";
import { DxButton } from "devextreme-vue/button";
import { DxToolbarItem } from "devextreme-vue/popup";
import { DxTooltip } from 'devextreme-vue/tooltip';
import LayoutSwitch from "./LayoutSwitch.vue";
import { DxDropDownButton } from "devextreme-vue/drop-down-button";
import { ref } from "vue";
import { DxPopup } from "devextreme-vue/popup";
import { defineProps } from 'vue';



let collapsed = false;
const selectedReport = ref([]);
const saveViews = ref([]);
const tooltip = ref({ text: '', target: null });


export default {
  props: {
    moduleRoute: String,
    slug: String,
    headers: Array,
    pivotHeaders: Array,
    moduleName: String,
    moduleLabel: String,
    dataRoute: String,
    layoutType: String,
    currentProduct: String,
    reports: {
      type: Object,
      default: () => {
        return {};
      },
    },
    saveViews: {
      type: Array,
      default: () => {
        return [];
      },
    }
  },
  components: {
    AppLayout,
    BsIndex,
    BsIndexPivot,
    PageTitle,
    JetNavLink,
    JetButton,
    MobileNavigation,
    MobileBsIndex,
    MobileNavigationBack,
    NavBar,
    DxButton,
    DxToolbarItem,
    DxTooltip,
    jetDropdownList,
    JetDropdownLink,
    LayoutSwitch,
    DxDropDownButton,
    DxPopup,
  },
  data() {
    return {

      // saveViews :[
      //   {name:"tanya",label:" tanya Gupta"},
      //   {name:"Kriti",label:" Kriti kumari"}

      //  ],


      cardData: [
        { id: 1, count: 8, label: "understanding" },
        { id: 2, count: 12, label: "analysis" },
        { id: 3, count: 15, label: "research" },
        { id: 1, count: 8, label: "understanding" },
        { id: 2, count: 12, label: "analysis" },
      ],
      options: [
        { id: 2, text: "Save As" }
      ],
      title: this.moduleLabel,
      currentLayout: 'list',
      appbarTitle: this.moduleRoute,
      itemSelected: false,
      selectedArr: [],
      isOpen: false,
      selectedOption: "All Items",
      defaultSaveText: "Save",
      dataGridRefKey: 'new value',
      gridState: null, // Store received state here
      showSavePopup: false,
      preferenceName: "",
      form: this.$inertia.form(),
      showSaveButton: false,
      showResetButton: false,
      showRenamePopup: false,
      currentPreferenceName: "",
      oldPreferenceName: "",
      currentPreferenceId: null,
      makeDefault: false,
      tooltip: {
        text: '',
        target: null,
      },

    };
  },
  methods: {

    loadReport(item) {
      console.log("Report Selected", item);
      this.selectedReport = item;
      console.log("report name", this.selectedReport.is_default);
      this.$inertia.get(`/${this.slug}/${this.moduleRoute}`, {
        selectedReport: item.is_default,
        name: item.name  // Add the name parameter
      });
    },
    showTooltip({ text, target }) {
      tooltip.value.text = text;
      tooltip.value.target = target;
    },
    filterActive() {
      console.log("Active Items selected");
    },
    filterInactive() {
      console.log("Inactive Items selected");
    },
    selectOption(option) {
      this.selectedOption = option.label;
      this.isOpen = false;
    },

    // refreshDatagrid() {

    //   this.$refs.bsIndexRef.refreshData();
    // },
    resetGrid() {
      if (this.$refs.bsIndexRef) {
        // Call loadCustomState method from child component
        this.$refs.bsIndexRef.loadCustomState();
        this.showSaveButton = false;
        this.showResetButton = false;

      }
    },
    renamePreference(event) {
      // if (event) {
      //   event.preventDefault();
      //   event.stopPropagation();
      // }

      // Check if a report is selected
      if (this.saveViews.selected) {
        this.currentPreferenceId = this.saveViews.selected.id;
        this.currentPreferenceName = this.saveViews.selected.name;
        this.oldPreferenceName = this.saveViews.selected.name;
        this.makeDefault = this.saveViews.selected.is_default || false;
        this.showRenamePopup = true;
      } else {
        alert("Please select a preference to rename");
      }
    },
    cancelRename() {
      this.showRenamePopup = false;
    },
    deletePreference() {
      if (!this.saveViews?.selected?.id) {
        alert("No layout selected for deletion.");
        return;
      }

      // Create and show a simple modal with both Delete and Cancel buttons
      const userChoice = window.confirm("Are you sure you want to delete this layout?\n\n(Press 'OK' to delete or 'Cancel' to go back)");

      if (userChoice) {
        const payload = {
          id: this.saveViews.selected.id
        };
        this.$inertia.delete(route("user-prefrences.deletelayout", [this.slug, payload]), {
          onSuccess: () => window.location.reload(),
          onError: (errors) => {
            alert(errors.message || "Failed to delete layout.");
          },
        });
      }
      // If userChoice is false (user clicked Cancel), nothing happens
    },


    sayHelloWorld() {
      alert("Hello world!");
    },
    goToCreate() {
      this.$inertia.get("/" + this.slug + "/" + this.moduleRoute + "/create");
      //   this.$inertia.get( this.moduleRoute + '/create');
    },
    // deleteMulti() {
    //   this.$inertia.get(
    //     route(this.moduleRoute + ".mutlidelete", [this.slug, this.selectedArr])
    //   );
    // },

    checkMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        console.log("CheckMobile Called: Mobile");
        return true;
      } else {
        console.log("CheckMobile Called: Desktop");
        return false;
      }
    },

    OnItemSelected(selectedValue) {
      // console.log("On Item Selected", selectedValue);
      this.selectedArr = selectedValue;
      if (this.selectedArr.length) {
        this.itemSelected = true;
      } else {
        this.itemSelected = false;
      }

      console.log("ARR VALUE", this.selectedArr);
    },
    getLastSegment(url) {
      // Split the URL by '/' and return the last segment
      const segments = url.split("/");
      return segments.pop(); // Get the last element (i.e., 'report1')
    },

    handleGridChange(isChanged) {
      this.showSaveButton = isChanged;
      this.showResetButton = isChanged;
    },
    async onButtonClick(e) {
      try {
        // Get current grid state from BsIndex component
        if (this.$refs.bsIndexRef) {
          const state = await this.$refs.bsIndexRef.getGridState();

          // Use preferenceName or fallback to 'default'
          const preferenceName = this.preferenceName || 'default';

          const payload = {
            name: preferenceName,  // Use preferenceName or 'default'
            state: JSON.stringify({ state }),  // Grid state in JSON format
            module: this.moduleName,
            is_default: preferenceName === 'default', // Set true if 'default', otherwise false
          };

          // Send the data to the server
          this.form.post(route("user-prefrences.store", [this.slug, payload]), {
            onSuccess: () => window.location.reload(),
          });
          this.showSaveButton = false;
          this.showResetButton = false;
        }
      } catch (error) {
        console.error('Error saving grid state:', error);
        alert('Error saving grid state');
      }
    },

    handleGridChange(isChanged) {

      this.showSaveButton = isChanged;
      this.showResetButton = isChanged
    },
    onItemClick(e) {
      if (e.itemData.text === "Save As") {
        this.showSavePopup = true; // Show the popup when "Save As" is clicked
      }
    },
    saveNewName() {
      const payload = {
        oldName: this.oldPreferenceName,
        newName: this.currentPreferenceName,
        is_default: this.makeDefault,
        module: this.moduleName,
      }

      this.form.post(route("user-prefrences.updatelayout", [this.slug, payload]), {
        onSuccess: () => window.location.reload(),
      });
      this.showRenamePopup = false;

    },
    setDefaultPreference() {
      if (!this.saveViews?.selected?.id) {
        alert("No layout selected for deletion.");
        return;
      }
      if (confirm("Are you sure you want to make this layout default?")) {
        const payload = {
          id: this.saveViews.selected.id,

        };

        this.$inertia.post(route("user-prefrences.defaultlayout", [this.slug, payload]), {
          onSuccess: () => window.location.reload(),
          onError: (errors) => {
            alert(errors.message || "Failed to make layout default.");
          },
        });
      }
    },
    handleTooltipShown({ text, target }) {
      this.tooltip.text = text;
      this.tooltip.target = target;

    },
    publishPreference() {
      if (!this.saveViews?.selected?.id) {
        alert("No layout selected for published.");
        return;
      }
      if (confirm("Are you sure you want to publish this layout?")) {
        const payload = {
          id: this.saveViews.selected.id,
        };

        this.$inertia.post(route("user-prefrences.publishlayout", [this.slug, payload]), {
          onSuccess: () => window.location.reload(),
          onError: (errors) => {
            alert(errors.message || "Failed to make layout default.");
          },
        });
      }
    }

  },
  computed: {
    selectedReportLabel() {
      ``
      const selectedReport = this.saveViews.preference_list.find(
        (view) => view.id === this.saveViews.selected?.id
      );

      return selectedReport ? selectedReport.name : 'All';
    }
  },
  mounted() {

    console.log("layout type", this.layoutType);
    console.log("selected report", this.handleGridChange);

  },
};
</script>
